import {
    EXPAND_SESSION,
    COLLAPSE_SESSION,
    ATTEMPT_FETCH_SESSION_DETAILS,
} from 'shared_redux/actions';

export const expand = (sessionId, athleteId) => (dispatch) => {
    dispatch({ type: EXPAND_SESSION, sessionId });
    dispatch({ type: ATTEMPT_FETCH_SESSION_DETAILS, athleteId, sessionId });
};

export const collapse = (sessionId) => ({ type: COLLAPSE_SESSION, sessionId });
